import { ConnectPermission } from '@connect-x-app/shared-domain-models';

export const hasPermission = (target: ConnectPermission[], required: ConnectPermission) => {
  return target.includes(required);
};

export const hasAllPermissions = (target: ConnectPermission[], required: ConnectPermission[]) => {
  const targetSet = new Set(target);
  return required.every(permission => targetSet.has(permission));
};

export const hasAnyPermission = (target: ConnectPermission[], required: ConnectPermission[]) => {
  const targetSet = new Set(target);
  return required.some(permission => targetSet.has(permission));
};
